import React from 'react';
import { StyledCardWrapper } from './Cards.styled';

const Cards = ({ children, style, cardsPerRow = 3, className }) => {
  return (
    <StyledCardWrapper
      style={{ ...style }}
      cardsPerRow={cardsPerRow}
      className={className}
    >
      {children}
    </StyledCardWrapper>
  );
};

export default Cards;
